var _mask, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDidpointLogo = function SvgDidpointLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_235_21857",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0003 0C51.2256 0 66 14.7744 66 32.9997C66 51.225 51.2256 66.0001 33.0003 66.0001C14.7744 66.0001 0 51.225 0 32.9997C0 14.7744 14.7744 0 33.0003 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0003 0C51.2256 0 66 14.7744 66 32.9997C66 51.225 51.2256 66.0001 33.0003 66.0001C14.7744 66.0001 0 51.225 0 32.9997C0 14.7744 14.7744 0 33.0003 0Z",
    fill: "#2471FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0003 0C51.2256 0 66 14.7744 66 32.9997C66 51.225 51.2256 66.0001 33.0003 66.0001C14.7744 66.0001 0 51.225 0 32.9997C0 14.7744 14.7744 0 33.0003 0Z",
    fill: "url(#paint0_linear_235_21857)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0003 1.375C50.4662 1.375 64.625 15.5338 64.625 32.9997H67.375C67.375 14.015 51.985 -1.375 33.0003 -1.375V1.375ZM64.625 32.9997C64.625 50.4657 50.4662 64.6251 33.0003 64.6251V67.3751C51.985 67.3751 67.375 51.9844 67.375 32.9997H64.625ZM33.0003 64.6251C15.5338 64.6251 1.375 50.4656 1.375 32.9997H-1.375C-1.375 51.9844 14.015 67.3751 33.0003 67.3751V64.6251ZM1.375 32.9997C1.375 15.5338 15.5338 1.375 33.0003 1.375V-1.375C14.015 -1.375 -1.375 14.015 -1.375 32.9997H1.375Z",
    fill: "#1862EA",
    fillOpacity: 0.12,
    mask: "url(#path-1-inside-1_235_21857)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51.5621C43.2444 51.5621 51.5625 43.2442 51.5625 33.0001C51.5625 28.8266 50.1907 24.9741 47.8558 21.8804C50.1032 20.1585 51.5625 17.4734 51.5625 14.4381H33C22.7556 14.4381 14.4375 22.756 14.4375 33.0001C14.4375 43.2151 22.7848 51.5621 33 51.5621ZM33 22.9311C38.5454 22.9311 43.0693 27.4549 43.0693 33.0001C43.0693 38.5454 38.5454 43.0691 33 43.0691C27.4546 43.0691 22.9307 38.5454 22.9307 33.0001C22.9307 27.4549 27.4546 22.9311 33 22.9311Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_21857",
    x1: 0,
    y1: 0,
    x2: 66,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7DFF"
  })))));
};
export default SvgDidpointLogo;